export class AdminRevenue {
  totalApprovedRevenue: number

  currentMonthApprovedRevenue: number

  currentDayApprovedRevenue: number

  constructor(data: Partial<AdminRevenue> = {}) {
    this.totalApprovedRevenue = data.totalApprovedRevenue ?? 0

    this.currentMonthApprovedRevenue = data.currentMonthApprovedRevenue ?? 0

    this.currentDayApprovedRevenue = data.currentDayApprovedRevenue ?? 0
  }
}
